// In-between sections
(function () {
  const breakpoint = 999;
  const images = document.querySelectorAll('.js-between-sections');

  const setPadding = function (sectionInner, prevSectionInner) {
    const padding = 120;

    sectionInner.style.paddingTop = `${padding}px`;
    prevSectionInner.style.paddingBottom = `${padding}px`;
  };

  const unsetPadding = function (sectionInner, prevSectionInner) {
    sectionInner.style.paddingTop = '';
    prevSectionInner.style.paddingBottom = '';
  };

  const setPositioning = function (section, image) {
    const positioning = -Math.abs(image.clientHeight / 2);

    section.style.position = 'relative';
    image.style.top = `${positioning}px`;
    image.classList.add('in-between--active');
  };

  const unsetPositioning = function (section, image) {
    section.style.position = '';
    image.style.top = '';
    image.classList.remove('in-between--active');
  };

  images.forEach(function (image) {
    const sectionInner = image.closest('.section__color-wrapper');
    const section = sectionInner.closest('.shopify-section');
    const prevSection = section.previousElementSibling;
    const prevSectionInner = prevSection.querySelector('.section__color-wrapper');

    try {
      window.matchMedia(`(max-width: ${breakpoint}px)`).addEventListener('change', function (mediaQueryString) {
        if (mediaQueryString.matches) {
          setPadding(sectionInner, prevSectionInner);
          setPositioning(section, image);
        } else {
          unsetPadding(sectionInner, prevSectionInner);
          unsetPositioning(section, image);
        }
      });
    } catch (error) {
      // Adds support for Safari <= 13.
      window.matchMedia(`(max-width: ${breakpoint}px)`).addListener(function (mediaQueryString) {
        if (mediaQueryString.matches) {
          setPadding(sectionInner, prevSectionInner);
          setPositioning(section, image);
        } else {
          unsetPadding(sectionInner, prevSectionInner);
          unsetPositioning(section, image);
        }
      });
    }

    if (window.innerWidth <= breakpoint) {
      setPadding(sectionInner, prevSectionInner);
      setPositioning(section, image);
    }
  });
})();

// Number counters
(function () {
  const initOdometer = function (counter) {
    const number = counter.querySelector('.js-counter__number');
    const speed = parseInt(counter.dataset.counterSpeed, 10) * 1000;
    const type = counter.dataset.counterType;
    const value = parseInt(counter.dataset.counterValue, 10);

    const odometer = new Odometer({
      el: number,
      value: (type === 'ticker') ? parseInt(number.textContent.replace(/,/g, ''), 10) : 0,
      duration: speed,
      animation: (type === 'ticker') ? null : 'count',
    });

    odometer.update(value);
  };

  const initFadeCounter = function (counter) {
    const number = counter.querySelector('.js-counter__number');
    number.innerHTML = number.textContent.replace(/\S/g, '<span>$&</span>');

    const spans = number.querySelectorAll('span');
    spans.forEach(function (span, index) {
      span.style.animationDelay = `${index * 0.2}s`;
    });
  };

  const initTickerCounter = function (counter) {
    const number = counter.querySelector('.js-counter__number');
    number.innerHTML = number.textContent.replace(/\S/g, '<span>$&</span>');

    const spans = number.querySelectorAll('span');
    spans.forEach(function (span) {
      const randomNumber = Math.floor(Math.random() * 10);

      if (isNaN(span.innerHTML)) {
        return;
      }

      span.innerHTML = randomNumber;
    });
  };

  const counters = document.querySelectorAll('.js-counter');
  counters.forEach(function (counter) {
    const type = counter.dataset.counterType;
    const counterObserver = new MutationObserver(function (mutationList, observer) {
      const counter = mutationList[0].target;

      if (counter.classList.contains('counter--active')) {
        observer.disconnect();
        initOdometer(counter);
      }
    });

    if (type === 'fade') {
      initFadeCounter(counter);
      return;
    }

    if (type === 'ticker') {
      initTickerCounter(counter);
    }

    counterObserver.observe(counter, { attributes: true, attributeFilter: ['class'] });
  });

  counters.forEach(function (counter) {
    const waypoint = new Waypoint({
      element: counter,
      offset: 'bottom-in-view',
      handler: function () {
        counter.classList.add('counter--active');
        waypoint.destroy();
      },
    });
  });
})();
